"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.render = void 0;
const vue_1 = require("vue");
const _withScopeId = n => ((0, vue_1.pushScopeId)("data-v-04a3b86a"), n = n(), (0, vue_1.popScopeId)(), n);
const _hoisted_1 = {
    key: 0,
    class: "disposal-application"
};
const _hoisted_2 = {
    key: 0,
    class: "disposal-application-menu"
};
function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_a_button = (0, vue_1.resolveComponent)("a-button");
    const _component_DescriptionList = (0, vue_1.resolveComponent)("DescriptionList");
    return (_ctx.id && _ctx.detail)
        ? ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", _hoisted_1, [
            (_ctx.extraData.overStatus && _ctx.extraData.vehicleStatus && _ctx.extraData.overStatus.value === '2' && _ctx.extraData.vehicleStatus.value === '2' && _ctx.hasRole(_ctx.role.dispose.build) && !_ctx.collapse)
                ? ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", _hoisted_2, [
                    (0, vue_1.createVNode)(_component_a_button, {
                        type: "primary",
                        onClick: _ctx.buildDispose
                    }, {
                        default: (0, vue_1.withCtx)(() => [
                            (0, vue_1.createTextVNode)("新增处置")
                        ]),
                        _: 1
                    }, 8, ["onClick"])
                ]))
                : (0, vue_1.createCommentVNode)("", true),
            (0, vue_1.createVNode)(_component_DescriptionList, {
                title: '车辆保全信息',
                column: 3,
                data: _ctx.detail,
                list: _ctx.description,
                extraData: _ctx.extraData,
                collapse: _ctx.collapse,
                onCollapse: _ctx.onCollapseChange
            }, null, 8, ["data", "list", "extraData", "collapse", "onCollapse"])
        ]))
        : (0, vue_1.createCommentVNode)("", true);
}
exports.render = render;
